import RelatedDocumentsBodyNavContent from './RelatedDocumentsBodyNavContent'

export default RelatedDocumentsBodyNavContent



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBodyNavContent/index.js